import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Collapse, Button, Select, Form, Input, message, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import axios from 'axios'
import RenderGlossary from './RenderGlossary'

const RenderFaq = ({ token, user }) => {
    const [displayForm, setDisplayForm] = useState(true)
    const [issueId, setIssueId] = useState(null)
    const [form] = Form.useForm()

    const onFinish = async (values) => {
        try {
            const res = await axios.post(
                process.env.REACT_APP_URL_GD6D + '?r=apiSav/postNewIssue',
                {
                    ...values,
                    memberId: user?.member_id,
                    memberName: `${user?.first_name || ''} ${user?.last_name || ''}`.trim(),
                    memberMail: user?.mail_address,
                    application: 'Ecosystème GD6D',
                },
                { headers: { Authorization: `Bearer ${token}` } }
            )
            const key = res?.data?.data?.ticket?.key
            if (key) setIssueId(key)
            setDisplayForm(false)
        } catch {
            message.error("Une erreur est survenue lors de l'envoi du formulaire.")
        }
    }

    const fileProps = {
        name: 'file',
        action: `${process.env.REACT_APP_URL_GD6D}?r=apiSav/postNewFile&issueId=${issueId}&jwt=${token}`,
        headers: { authorization: 'authorization-text' },
        onChange(info) {
            if (info.file.status === 'done') message.success(`${info.file.name} ajouté avec succès`)
            else if (info.file.status === 'error') message.error(`${info.file.name} échec.`)
        },
    }

    const savContent = displayForm ? (
        <div className="wrap-sav-form">
            <div className="sav-form-content">
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item name="type" label="Type de demande" rules={[{ required: true, message: 'Champ requis' }]}>
                        <Select placeholder="Sélectionner" allowClear options={[
                            { value: 'Bug', label: 'Bug' },
                            { value: 'Contenu', label: 'Problème de contenu' },
                            { value: 'Fonctionnalité', label: 'Suggestion de fonctionnalité' },
                        ]} />
                    </Form.Item>
                    <Form.Item name="title" label="Titre" rules={[{ required: true, message: 'Champ requis' }, { max: 255, message: '255 caractères maximum' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="criticality" label="Criticité" rules={[{ required: true, message: 'Champ requis' }]}>
                        <Select placeholder="Sélectionner" allowClear options={[
                            { value: 'Genant', label: 'Gênant — je suis limité(e) dans mon travail' },
                            { value: 'Bloquant', label: 'Bloquant — je ne peux pas faire mon travail' },
                        ]} />
                    </Form.Item>
                    <Form.Item name="content" label="Votre demande" rules={[{ required: true, message: 'Champ requis' }]}>
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <div className="sav-form-validation-button">
                        <Button type="primary" htmlType="submit">Envoyer</Button>
                    </div>
                </Form>
            </div>
        </div>
    ) : (
        <>
            <p>Votre demande a bien été envoyée.{issueId ? ` (Référence : ${issueId})` : ''}</p>
            {issueId && (
                <Upload {...fileProps}>
                    <Button icon={<UploadOutlined />}>Ajouter une pièce jointe</Button>
                </Upload>
            )}
            <div className="sav-modal-end-button-wrap">
                <Button type="dashed" onClick={() => { setDisplayForm(true); setIssueId(null); form.resetFields() }}>
                    Terminer
                </Button>
            </div>
        </>
    )

    const items = [
        {
            key: '1',
            label: 'Lexique',
            children: <RenderGlossary />,
        },
        {
            key: '2',
            label: 'Contacter le support',
            children: savContent,
        },
    ]

    return (
        <div className="wrap-sav">
            <Collapse accordion defaultActiveKey={['1']} items={items} className="faq-collapse" />
        </div>
    )
}

const mapStateToProps = state => ({
    token: state.user.token,
    user: state.user.infos,
})

export default connect(mapStateToProps)(RenderFaq)
